import { ElectionMigrationEntity } from '../../app/feathers/election-migration-runs/ElectionMigrationRun';

type PrimaryPrecedentEntry = {
  _id: string;
  maxChoices?: number;
};

function sourceRaceForCandidateId(entity: ElectionMigrationEntity, candidateId: string): string | null {
  const id = `${candidateId}`;
  for (const row of entity.sourceCandidateSummaries || []) {
    const ids = (row.candidateSummary?.ids || []).map((candidateSummaryId) => `${candidateSummaryId}`);
    if (ids.includes(id)) {
      return `${row.raceId}`;
    }
  }
  return null;
}

function maxWinnerSelectionsForSourceRace(entity: ElectionMigrationEntity, raceId: string): number {
  const primaryPrecedents = entity.createPayload?.primaryPrecedent as PrimaryPrecedentEntry[] | undefined;
  const entry = primaryPrecedents?.find((precedent) => `${precedent?._id}` === `${raceId}`);
  const maxSelections = Number(entry?.maxChoices);
  return Number.isFinite(maxSelections) && maxSelections >= 1 ? maxSelections : 1;
}

/**
 * Primary→general: allow up to the expected winner count for each source primary.
 * Runoff: allow multiple selections from the single source race.
 */
export function toggleWinnerSelection(
  entity: ElectionMigrationEntity,
  candidateId: string,
  current: string[]
): string[] {
  const id = `${candidateId}`;
  if (current.includes(id)) {
    return current.filter((selectedId) => selectedId !== id);
  }
  if (entity.migrationKind !== 'primary-to-general') {
    return [...current, id];
  }
  const home = sourceRaceForCandidateId(entity, id);
  if (!home) {
    return current;
  }
  const selectedFromHome = current.filter(
    (selectedId) => sourceRaceForCandidateId(entity, selectedId) === home
  );
  if (selectedFromHome.length >= maxWinnerSelectionsForSourceRace(entity, home)) {
    return current;
  }
  return [...current, id];
}
